import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const AuthModal = ({ isOpen, onClose }) => {
  const { login, user } = useAuth();

  // Close modal once the user is authenticated
  useEffect(() => {
    if (user && isOpen) onClose();
  }, [user, isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      data-testid="auth-modal"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.72)',
        backdropFilter: 'blur(10px)',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: 'linear-gradient(180deg, #1a0e2e 0%, #0f0a1e 100%)',
          border: '1px solid rgba(139, 92, 246, 0.3)',
          borderRadius: '20px',
          padding: '44px 36px 36px',
          width: '100%',
          maxWidth: '420px',
          position: 'relative',
          boxShadow: '0 30px 80px rgba(0, 0, 0, 0.5)',
        }}
      >
        {/* Close */}
        <button
          data-testid="auth-modal-close"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '14px',
            right: '14px',
            background: 'none',
            border: 'none',
            color: '#8885a0',
            cursor: 'pointer',
            padding: 4,
          }}
        >
          <X size={22} />
        </button>

        {/* Header */}
        <h2
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '26px',
            fontWeight: 700,
            textAlign: 'center',
            margin: '0 0 8px',
            color: '#ffffff',
          }}
        >
          <span style={{ color: '#00d4ff' }}>Inner</span>{' '}
          <span style={{ color: '#c084fc' }}>Bridge</span>
        </h2>
        <p
          style={{
            textAlign: 'center',
            fontSize: '14px',
            color: '#8885a0',
            margin: '0 0 32px',
            lineHeight: 1.6,
          }}
        >
          Sign in to continue your spiritual journey
        </p>

        {/* Google OAuth Button — the ONLY sign-in method */}
        <button
          data-testid="google-signin-button"
          onClick={login}
          style={{
            width: '100%',
            padding: '14px 18px',
            borderRadius: '12px',
            border: '1px solid rgba(139, 92, 246, 0.35)',
            background: '#ffffff',
            color: '#1f1f1f',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'Inter, sans-serif',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(139, 92, 246, 0.25)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <svg width="20" height="20" viewBox="0 0 18 18" fill="none">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
            <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.259c-.806.54-1.837.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009.003 18z" fill="#34A853"/>
            <path d="M3.964 10.712A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.33z" fill="#FBBC05"/>
            <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9.002 3.58z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        {/* Fine print */}
        <p
          style={{
            textAlign: 'center',
            fontSize: '12px',
            color: '#6b6880',
            marginTop: '24px',
            lineHeight: 1.7,
          }}
        >
          By continuing, you agree to Inner Bridge's Terms of Service
          <br />
          and acknowledge our Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AuthModal;
